const EURO_FORMATTER = new Intl.NumberFormat("fr-FR", {
  style: "currency",
  currency: "EUR",
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

export const formatEurosCents = (cents: number | null | undefined): string => {
  if (cents === null || cents === undefined) return "";
  return EURO_FORMATTER.format(cents / 100);
};

export const applyDiscountPercent = (cents: number, percent: number): number =>
  Math.round(cents * (1 - percent / 100));
